<template>
  <div class="xcard">
    <h3 class="text-center" style="margin-top:0"> Dashboard Metas de Inscripciones</h3>
    <p class="text-center text-primary"> <small>Que comience el juego</small> </p>
    <hr>

    <div class="row">
      <div class="col-sm-5">
        <Sedes :model="sede"/>
        <p> <small></small> </p>
        <Usuarios :model="sede" :idsede="sede.idsede.id" :multiple="true"/>
      </div>

      <div class="col-sm-7">
        <div class="row">
          <div class="col-sm-2"> <input class="form-control input-sm" type="number" placeholder="Meta 1" v-model="meta1"> <small>cursos</small> </div>
          <div class="col-sm-2"> <input class="form-control input-sm" type="number" placeholder="Meta 2" v-model="meta2"> <small>diplomados</small> </div>
          <div class="col-sm-2"> <input class="form-control input-sm" type="number" placeholder="Meta 3" v-model="meta3"> <small>especialidades</small> </div>
          <div class="col-sm-2"> <input class="form-control input-sm" type="number" placeholder="Meta 4" v-model="meta4"> <small>maestrias</small> </div>
        </div>

        <div class="row">
          <div class="col-sm-5" :class="{'has-error': validation.hasError('busqueda.fecha_ini')}">
          <Fecha :model="busqueda" :valueto="'fecha_ini'" :default="busqueda.fecha_ini"/>
          <small>Desde (un mes atras)</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_ini')"> {{validation.firstError('busqueda.fecha_ini')}} </div>
        </div>
        <div class="col-sm-5" :class="{'has-error': validation.hasError('busqueda.fecha_fin')}">
          <Fecha :model="busqueda" :valueto="'fecha_fin'" :default="busqueda.fecha_fin"/>
          <small>Hasta (ahora)</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_fin')"> {{validation.firstError('busqueda.fecha_fin')}} </div>
        </div>
        <div class="col-sm-2"> <button class="btn btn-sm btn-azul" @click="clickBuscar()"> Iniciar </button> </div>
        </div>

      </div>
    </div>

    <p class="text-primary"> <small>Seleccione los asesores, las fechas de inicio y fin, despues seleccione el boton de <b>iniciar</b> para ver los resultados</small> </p>
    <Alertas ref="alertar" />

    <span v-show="datos.length > 0">
      <button class="btn btn-link" type="button" @click="cambiarTipo()"> <span class="glyphicon glyphicon-eye-open"></span> Cambiar vista</button>    
    </span>

    <div v-show="tipo_tabla">
      <div class="table-responsive compress">
        
        <span v-show="datos.length > 0" class="pull-right">
          <input type="radio" v-model="tipo_tabla_filtro" :value="-1"> Todo
          <input type="radio" v-model="tipo_tabla_filtro" :value="0"> Cursos
          <input type="radio" v-model="tipo_tabla_filtro" :value="1"> Diplomados
          <input type="radio" v-model="tipo_tabla_filtro" :value="2"> Especialidades
          <input type="radio" v-model="tipo_tabla_filtro" :value="3"> Maestrias
        </span> 
        <table class="table table-striped table-bordered datatable table-hover"> 
          <thead></thead>
          <tbody>
            <tr style="background:#E9ECEF;vertical-align:middle;" class="text-center">
              <th rowspan="3" class="text-center" style="vertical-align: middle;"> No </th>
              <th rowspan="3" class="text-center" style="vertical-align: middle;"> Nombres y Apellidos </th>
              <th colspan="8" class="text-center" style="vertical-align: middle;"> Objectivos </th>
              <th rowspan="3" class="text-center" style="vertical-align: middle;">Total</th>
            </tr>
          
          <tr style="background: #E5E8EB;">
              <td colspan="2" v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 0" class="text-center" style="background:#4A8F2E;color:white">Cursos ({{meta1}}) </td>
              <td colspan="2" v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 1" class="text-center" style="background:#866C1B;color:white">Diplomados ({{meta2}}) </td>
              <td colspan="2" v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 2" class="text-center" style="background:#37598F;color:white">Especialidades ({{meta3}}) </td>
              <td colspan="2" v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 3" class="text-center" style="background:#695F87;color:white">Maestrias ({{meta4}}) </td>
              
            </tr>
            
            <tr>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 0" style="background:#75A068;color:white" > <small>Inscritos</small> </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 0" style="background:#75A068;color:white" > <small> % </small> </td>

              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 1" style="background:#D7C07C;color:white" > <small>Inscritos</small> </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 1" style="background:#D7C07C;color:white" > <small> % </small> </td>

              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 2" style="background:#6180D9;color:white" > <small>Inscritos</small> </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 2" style="background:#6180D9;color:white" > <small> % </small> </td>

              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 3" style="background:#949DA8;color:white" > <small>Inscritos</small> </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 3" style="background:#949DA8;color:white" > <small> % </small> </td>
            </tr>

            <tr v-bind:key="ind" v-for="(a,ind) in usuarios">
              <td> {{ind+1}} </td>
              <td> {{parseUs(a)}} <small v-if="a.loading" class="text-danger"><b>...</b></small> </td>

              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 0" style="padding:0px!important;background:#B5CAAC" v-html="metax(a.meta4,a.meta4 * 100/ meta1)"> </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 0" style="padding:0px!important;background:#B5CAAC" v-html="roundx(a.meta4 * 100/ meta1)"> </td>

              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 1" style="padding:0px!important;background:#F4E0A6" v-html="metax(a.meta1,a.meta1 * 100/ meta2)"> </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 1" style="padding:0px!important;background:#F4E0A6" v-html="roundx(a.meta1 * 100/ meta2)"> </td>

              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 2" style="padding:0px!important;background:#BDD0EF" v-html="metax(a.meta2,a.meta2 * 100/ meta3)"> </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 2" style="padding:0px!important;background:#BDD0EF" v-html="roundx(a.meta2 * 100/ meta3)"> </td>

              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 3" style="padding:0px!important;background:#CCC7D6" v-html="metax(a.meta3,a.meta3 * 100/ meta4)"> </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 3" style="padding:0px!important;background:#CCC7D6" v-html="roundx(a.meta3 * 100/ meta4)"> </td>

              <td v-show="tipo_tabla_filtro == -1" class="text-center"> {{a.total}} </td>
            </tr>

            <tr>
              <td colspan="2"></td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 0"> {{totales.d}} </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 0"></td>            
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 1"> {{totales.a}} </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 1"></td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 2"> {{totales.b}} </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 2"></td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 3"> {{totales.c}} </td>
              <td v-show="tipo_tabla_filtro == -1 || tipo_tabla_filtro == 3"></td>
              <td v-show="tipo_tabla_filtro == -1" style="background:#009800;color:white"> {{totales.e}} </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
    
    <div v-show="!tipo_tabla">
      <canvas id="semacanvas"></canvas>
    </div>

  

    

    <notifications group="auth" position="bottom right" />
  </div>
</template>

<style lang="css">
.compress td{
  padding-top: 6px!important;
  padding-bottom: 6px!important;
  text-align: center;
}
</style>

<script>
import Sedes from '@/components/ASedes'
import Usuarios from '@/components/AUsuariosSemaforoMarketing.vue'
import Alertas from '@/components/AAlertas.vue'
import {parseJsonError,error} from '@/components/Utils.js'
import Fecha from '@/components/AFecha.vue'
import { Validator } from 'simple-vue-validator'
import gql from 'graphql-tag'
export default {
  data(){
    return{
      usuarios:[],
      meta1:6,meta2:5,meta3:4,meta4:3,
      sede: {idsede:{},idusuario:[]},
      datos:[],//{nombre:'',cantidades:[]}
      grafico: null,
      busqueda: { fecha_ini: null,fecha_fin: null, },
      totales: {a:0,b:0,c:0,d:0,e:0},
      tipo_tabla: true,
      tipo_tabla_filtro: -1,
    }
  },
  components:{ Sedes,Fecha,Usuarios,Alertas },
  validators: {
      'busqueda.fecha_ini'(value){ return Validator.value(value).required(); },
      'busqueda.fecha_fin'(value){ return Validator.value(value).required(); },
  },
  watch:{ 
    'sede.idusuario': function( a ){
      window.console.log( a )

      this.usuarios =[]
      var vue = this;
      a.forEach( function(e){ 
        vue.usuarios.push( 
          {
            id:e.id,
            nombres:e.nombres,
            meta1:0,
            meta2:0,
            meta3:0,
            meta4:0,
            color:'background:red',
            loading: false,
            nom: '-',
            cobros: '-',
            total: 0,
          } 
        ) 
      });

      //this.clickBuscar(); // opcional
    },
    'sede.idsede': function(){
      //this.usuarios =[]
    }
  },
  methods:{
    clickBuscar(){
      if( !this.busqueda.fecha_ini || !this.busqueda.fecha_fin || this.sede.idusuario.length == 0 ){
        this.$notify( error( 'Faltan parametros','Complete los campos' ) )
        return;
      }

      this.semaforoistener();
    },
    parseUs( dp ){ //datos_personales
			if( dp == null ) return "-";
      if( dp.pri_apellido== null ) dp.pri_apellido = "";
      if( dp.seg_apellido== null ) dp.seg_apellido = "";
			return dp.nombres+" "+dp.pri_apellido+" "+dp.seg_apellido;
    },
    parseTotal(){ return 0; },
    roundx(num, decimales = 0) {
      var signo = (num >= 0 ? 1 : -1);
      var porc = num;
      num = num * signo;
      if (decimales === 0) porc = signo * Math.round(num);
      else{
        num = num.toString().split('e');
        num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
        num = num.toString().split('e');
        porc = signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
      }

      if( porc > 100) return '<small style="background:#009800;color:white;width:100%!important;height:38px;display:block;">'+porc+'%</small>'
      else if( porc >= 60) return '<small style="background:#FFEE58;color:black;width:100%!important;height:38px;display:block;">'+porc+'%</small>'
      else return '<small style="background:#DD2C00;color:white;width:100%!important;height:38px;display:block;">'+porc+'%</small>'
    },
    metax(meta,num, decimales = 0) {
      var signo = (num >= 0 ? 1 : -1);
      var porc = num;
      num = num * signo;
      if (decimales === 0) porc = signo * Math.round(num);
      else{
        num = num.toString().split('e');
        num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
        num = num.toString().split('e');
        porc = signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
      }
      
      if( porc > 100) return '<b style="background:#009800;color:white;width:100%!important;height:38px;display:inline-block;">'+meta+'</b>'
      else if( porc >= 60) return '<b style="background:#FFEE58;color:black;width:100%!important;height:38px;display:inline-block;">'+meta+'</b>'
      else return '<b style="background:#DD2C00;color:white;width:100%!important;height:38px;display:inline-block;">'+meta+'</b>'
    },

    async semaforoistener(){
      var vue = this;
      this.usuarios.forEach( async function(e,i){
        await vue.getInscripciones( e,i )
      });
    },

    cambiarTipo(){
      this.tipo_tabla = !this.tipo_tabla;
    },
    cambiarTipoFiltro( nuevo ){
      this.tipo_tabla_filtro = nuevo;
    },
    
    parseColorMetaCanvas( num){
      var signo = (num >= 0 ? 1 : -1);
      var porc = num;
      num = num * signo;
      porc = signo * Math.round(num);
      if( porc > 100) return '#009800AA'
      else if( porc >= 60) return '#FFEE58'
      else return '#DD2C00'
    },
    creagrafico(){
      var vue = this;
      var config = {
        type: 'bar',
        data:{
          datasets: [
            {
              label: 'Cursos',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1
            },
            {
              label: 'Diplomados',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1
            },
            {
              label: 'Especialidades',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1
            },
            {
              label: 'Maestrias',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1
            },
          ],
          labels: []
        },
        options:{
          responsive: true,
          scales: {
            xAxes: [{
                gridLines: { offsetGridLines: true }
            }]
          }
        }
      }

      this.datos.forEach( function(e){
        var m3 = vue.parseColorMetaCanvas( (e.cantidades[3] * 100) / vue.meta1)
        var m0 = vue.parseColorMetaCanvas( (e.cantidades[0] * 100) / vue.meta2)
        var m1 = vue.parseColorMetaCanvas( (e.cantidades[1] * 100) / vue.meta3)
        var m2 = vue.parseColorMetaCanvas( (e.cantidades[2] * 100) / vue.meta4)
        config.data.datasets[0].data.push(e.cantidades[3])// cursos
        config.data.datasets[1].data.push(e.cantidades[0])//dip
        config.data.datasets[2].data.push(e.cantidades[1])//esp
        config.data.datasets[3].data.push(e.cantidades[2])//mae
        config.data.datasets[0].backgroundColor.push( m3 )
        config.data.datasets[1].backgroundColor.push( m0 )
        config.data.datasets[2].backgroundColor.push( m1 )
        config.data.datasets[3].backgroundColor.push( m2 )
        config.data.labels.push( e.nombre )
      })

      var ctx1 = document.getElementById( 'semacanvas' ).getContext('2d');
      if( this.grafico ) this.grafico.destroy();
      this.grafico = new window.Chart(ctx1, config);
    },

    async getInscripciones( user,index ){
      var vue = this;
      vue.datos = [];
      //var sql = gql`query{ getInscripcionesByUser(user:${user.id},fechas:{fecha_ini:"${this.busqueda.fecha_ini}",fecha_fin:"${this.busqueda.fecha_fin}"}){id,cuotas_canceladas{monto,saldo},programa{postgrado{nombre,idcategoria,categoria{id,nombre}}}} }`
      var sql = gql`query{ getInscripcionesByUser(user:${user.id},fechas:{fecha_ini:"${this.busqueda.fecha_ini}",fecha_fin:"${this.busqueda.fecha_fin}"}){id,programa{postgrado{nombre,idcategoria,categoria{id,nombre}}}} }`
      //window.console.log( ">>>>>>>>>>>>> ",sql );
      this.$refs.alertar.cargando();
      user.loading = true;

      await this.$apollo.query({
        query: sql,
        }).then((data) => {
          var lista = data.data.getInscripcionesByUser;
          var usu = vue.usuarios.find( x => x.id == user.id );
          if( usu ){
            var a = [];
            var b = [];
            var c = [];
            var d = [];
            //var m = 0;
            //var nom = '';
            lista.forEach( function(e){
              //nom += e.programa.postgrado.categoria.nombre+'-'+e.programa.postgrado.nombre+', ';
              //window.console.log( "MMMM",e.cuotas_canceladas )
              if(e.programa.postgrado.categoria.id==1) a.push( e.id )
              else if(e.programa.postgrado.categoria.id==2) b.push( e.id )
              else if(e.programa.postgrado.categoria.id==3) c.push( e.id )
              else if(e.programa.postgrado.categoria.id==5) d.push( e.id )
            });
            user.meta1 = a.length;
            user.meta2 = b.length;
            user.meta3 = c.length;
            user.meta4 = d.length;
            user.loading = false;
            var noms = user.nombres.split(' ');
            vue.datos.push( {nombre:noms[0]+' '+noms[1],cantidades:[user.meta1,user.meta2,user.meta3,user.meta4]} )

            user.total = user.meta1+user.meta2+user.meta3+user.meta4;
            vue.totales.a += user.meta1;
            vue.totales.b += user.meta2;
            vue.totales.c += user.meta3;
            vue.totales.d += user.meta4;
            vue.totales.e += user.total;
            //user.nom = nom;
          }

          //window.console.log( "--------------------------",user );
          this.$refs.alertar.reset();
          if( index == this.usuarios.length-1 ){
            this.creagrafico();
            window.console.log( "DATOS: ",window.stringifyObject(vue.datos) )
          }
        }).catch((error) => {
          vue.$refs.alertar.reset();
          window.console.error(error)
          this.$notify( parseJsonError( error,'getInscripcionesByUser' ) )
        })
    },
  },
  mounted(){
    var date = new Date();
    var date2 = new Date();
    date.setDate( date.getDate()-31 )
    var d1 = date.getDate()
    var m1 = date.getMonth()+1
    var d2 = date2.getDate()
    var m2 = date2.getMonth()+1
    if( d1 < 10 ) d1 = '0'+d1;
    if( m1 < 10 ) m1 = '0'+m1;
    if( d2 < 10 ) d2 = '0'+d2;
    if( m2 < 10 ) m2 = '0'+m2;

    var f1 = date.getFullYear()+'-'+m1+'-'+d1;
    var f2 = date2.getFullYear()+'-'+m2+'-'+d2;

    this.busqueda.fecha_ini = f1;
    this.busqueda.fecha_fin = f2;
  }
}
</script>